import * as v from "valibot";
import { rpcContract } from "../rpc";

export const enqueueRecordingRpcContract = rpcContract({
  name: "enqueue-recording",
  paramsSchema: v.object({
    liveEventId: v.string(),
  }),
  resultSchema: v.object({
    status: v.string(),
    recordingUrl: v.nullable(v.string()),
  }),
});

export type EnqueueRecordingParams = v.InferOutput<(typeof enqueueRecordingRpcContract)["paramsSchema"]>;
export type EnqueueRecordingResult = v.InferOutput<(typeof enqueueRecordingRpcContract)["resultSchema"]>;
